import React, { createRef } from 'react';
import { Grid } from '@material-ui/core';
import { Card, CardHeader, CardContent, LinearProgress, Button, CircularProgress, } from '@mui/material';
import StreamingPanel from './StreamingPanel'
import AnnotationPanel from './AnnotationPanel'
import axios from 'axios';

const STATUS_IDLE = 0
const STATUS_UPLOADING = 1

export default class VideoPrediction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      videoFile: null,
      isProcessing: false,
      isLoading: false,
      currentFrame: 0,
      totalFrames: 0,
      isPlaying: true,
      error: null,
      frames: new Map(), // Lưu trữ frame data và predictions
      wsConnection: null,
      // Drawing states
      isDrawing: false,
      startPos: { x: 0, y: 0 },
      userBoxes: new Map(), // Map frameNumber -> array of boxes
      selectedBox: null,
      drawingMode: 'yolo', // 'yolo' or 'manual',

      persistentBoxes: [], // Lưu các boxes cố định xuyên suốt video
      trackingMode: 'frame', // 'frame' hoặc 'persistent'
      patientID: "",
      patientName: "",
      sampleID: "",
      collectionDate: "",
      isEditing: false,

      selectedFrameData: null,  // Lưu frame data đã chọn
      selectedFrameNumber: null, // Lưu số frame đã chọn
      selectedFrame: null,
      selectedFrameOrigin: null,
      selectedFrameDataOrigin: null,

      status: STATUS_IDLE,
    };

    this.canvasRef = createRef();
    this.animationFrame = null;
    this.CHUNK_SIZE = 1024 * 1024; // 1MB chunks
  }

  componentDidMount() {
    const {
      patientID,
      patientName,
      sampleID,
      collectionDate
    } = this.props
    this.setState({
      patientID,
      patientName,
      sampleID,
      collectionDate
    })
  }


  componentDidUpdate(prevProps) {
    // So sánh props hiện tại với props trước đó
    if (this.props.patientID !== prevProps.patientID || this.props.patientName !== prevProps.patientName ||
      this.props.sampleID !== prevProps.sampleID || this.props.collectionDate !== prevProps.collectionDate
    ) {
      // console.log(this.props)
      // Thực hiện các hành động khi props thay đổi
      // this.handlePropsChange();
      const {
        patientID,
        patientName,
        sampleID,
        collectionDate
      } = this.props
      this.setState({
        patientID,
        patientName,
        sampleID,
        collectionDate
      })
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    // Chỉ re-render khi cần thiết
    return (
      this.state.patientID !== nextProps.patientID ||
      this.state.patientName !== nextProps.patientName ||
      this.state.sampleID !== nextProps.sampleID ||
      this.state.collectionDate !== nextProps.collectionDate ||

      this.state.isPlaying !== nextState.isPlaying ||
      this.state.currentFrame !== nextState.currentFrame ||
      this.state.selectedBox !== nextState.selectedBox ||
      this.state.drawingMode !== nextState.drawingMode ||
      this.state.trackingMode !== nextState.trackingMode ||
      this.state.isProcessing !== nextState.isProcessing
    );
  }

  componentWillUnmount() {
    this.cleanupBeforeNewFile();
  }


  connectWebSocket = () => {
    try {
      console.log('Establishing new WebSocket connection...');
      const ws = new WebSocket('wss://sperms.ailab.vn:5005/ws/predict');

      ws.onopen = () => {
        console.log('WebSocket Connected');
        this.setState({
          wsConnection: ws,
          error: null  // Clear any previous errors
        });
        this.startVideoProcessing();
      };

      ws.onmessage = (event) => {
        const data = JSON.parse(event.data);

        if (data.type === 'end') {
          this.setState({
            totalFrames: data.total_frames,
            isProcessing: false
          });
          return;
        }

        // Lưu frame và predictions
        this.setState(prevState => {
          const newFrames = new Map(prevState.frames);
          newFrames.set(data.frame_number, {
            image_cv: data.frame_data_cv,
            image: data.frame_data,
            predictions: data.predictions
          });
          return {
            frames: newFrames,
            currentFrame: data.frame_number,
          };
        });

        // Vẽ frame nếu đang playing
        if (this.state.isPlaying) {
          this.drawFrame(data.frame_number);
        }
      };

      ws.onerror = (error) => {
        console.error('WebSocket Error:', error);
        this.setState({
          error: 'Connection error occurred. Please try again.',
          isProcessing: false
        });
      };

      ws.onclose = () => {
        console.log('WebSocket Connection Closed');
        this.setState(prevState => ({
          wsConnection: null,
          // Chỉ set error nếu đang processing để tránh hiển thị lỗi khi đóng có chủ ý
          error: prevState.isProcessing ? 'Connection closed unexpectedly' : null,
          isProcessing: false
        }));
      };

    } catch (error) {
      console.error('WebSocket connection error:', error);
      this.setState({
        error: 'Failed to connect to server. Please try again.',
        isProcessing: false
      });
    }
  }

  disconnectWebSocket = () => {
    if (this.state.wsConnection) {
      this.state.wsConnection.close();
    }
  }

  togglePlay = () => {
    // Không cho phép play nếu đang vẽ hoặc edit box
    if (this.state.isDrawing || this.state.isEditing) {
      return;
    }

    this.setState(prevState => {
      const isPlaying = !prevState.isPlaying;

      if (isPlaying) {
        this.playFrames();
      } else {
        if (this.animationFrame) {
          cancelAnimationFrame(this.animationFrame);
          this.animationFrame = null;
        }
      }

      return { isPlaying };
    });
  }

  playFrames = () => {
    // Không play nếu đang vẽ hoặc edit
    if (this.state.isDrawing || this.state.isEditing) {
      return;
    }

    const { currentFrame, totalFrames } = this.state;

    if (currentFrame >= totalFrames - 1) {
      this.setState({ currentFrame: 0 });
    }

    this.drawCurrentFrame();

    this.setState(prevState => ({
      currentFrame: (prevState.currentFrame + 1) % totalFrames
    }));

    if (this.state.isPlaying) {
      this.animationFrame = requestAnimationFrame(this.playFrames);
    }
  }

  captureFrame = () => {
    const { currentFrame, frames } = this.state;
    const frameData = frames.get(currentFrame);
    if (frameData) {
      this.setState({
        selectedFrame: frames,
        selectedFrameDataOrigin: frameData,
        selectedFrameData: frameData,
        selectedFrameNumber: currentFrame
      },() => {this.togglePlay()});
    }
  }

  drawCurrentFrame = () => {
    const canvas = this.canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const {
      currentFrame,
      frames,
    } = this.state;

    const frameData = frames.get(currentFrame);
    if (!frameData) return;

    const image = new Image();
    image.onload = () => {
      canvas.width = image.width;
      canvas.height = image.height;
      ctx.drawImage(image, 0, 0);
    };
    image.src = `data:image/jpeg;base64,${frameData.image_cv}`;
  }


  handleFileSelect = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!file.type.startsWith('video/')) {
      this.setState({ error: 'Please select a valid video file' });
      return;
    }

    // Cleanup trước khi xử lý file mới
    await this.cleanupBeforeNewFile();

    // Set state với file mới
    this.setState({
      videoFile: file,
      frames: new Map(),
      currentFrame: 0,
      isPlaying: true,
      error: null,
      persistentBoxes: [], // Reset boxes
      userBoxes: new Map(), // Reset user boxes
      selectedBox: null
    }, async () => {
      const {
        patientID,
        patientName,
        sampleID,
        collectionDate
      } = this.state

      // console.log('sampleID',sampleID)
      const formData = new FormData();
      formData.append('patient_id', patientID);
      formData.append('patient_name', patientName);
      formData.append('sample_id', sampleID);
      formData.append('collection_date', collectionDate);

      const response = await axios.post('https://sperms.ailab.vn:5008/upload/', formData);
      // console.log(response.data)
      if(response.status === 200){
        // alert('Upload video thành công')
      } else {
        alert('Có lỗi xảy ra vui lòng thử lại !')
      }      
    });

    // Tạo kết nối WebSocket mới
    this.connectWebSocket();
  }

  // Thêm method mới để cleanup
  cleanupBeforeNewFile = async () => {
    // Dừng video nếu đang chạy
    if (this.state.isPlaying) {
      this.pauseVideo();
    }

    // Hủy animation frame nếu có
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
      this.animationFrame = null;
    }

    // Ngắt kết nối WebSocket hiện tại nếu có
    if (this.state.wsConnection) {
      console.log('Disconnecting existing WebSocket connection...');
      this.state.wsConnection.close();
      await new Promise(resolve => setTimeout(resolve, 100)); // Đợi một chút để WS đóng hoàn toàn
    }

    // Reset canvas
    const canvas = this.canvasRef.current;
    if (canvas) {
      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    }
  }

  startVideoProcessing = async () => {
    const { videoFile, wsConnection } = this.state;
    if (!videoFile || !wsConnection) return;

    this.setState({ isProcessing: true });

    try {
      // Đọc và gửi video theo chunks
      const reader = new FileReader();
      const blob = videoFile;
      const chunks = Math.ceil(blob.size / this.CHUNK_SIZE);

      for (let i = 0; i < chunks; i++) {
        const start = i * this.CHUNK_SIZE;
        const end = Math.min(start + this.CHUNK_SIZE, blob.size);
        const chunk = blob.slice(start, end);

        // Đọc và gửi từng chunk
        const buffer = await chunk.arrayBuffer();
        wsConnection.send(buffer);

        // Update progress
        this.setState({
          progress: Math.round((i + 1) * 100 / chunks)
        });
      }

    } catch (error) {
      console.error('Error processing video:', error);
      this.setState({
        error: 'Error processing video. Please try again.',
        isProcessing: false
      });
    }
  }

  pauseVideo = () => {
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
      this.animationFrame = null;
    }
    this.setState({ isPlaying: false });
  }

  drawFrame = (frameNumber) => {
    const canvas = this.canvasRef.current;
    if (!canvas) return;

    const frameData = this.state.frames.get(frameNumber);
    if (!frameData) return;

    const ctx = canvas.getContext('2d');
    
    // Draw frame
    const image = new Image();
    image.onload = () => {
      canvas.width = image.width;
      canvas.height = image.height;
      ctx.drawImage(image, 0, 0);

      // Draw predictions
      // frameData.predictions.forEach(pred => {
      //   const { bbox, class: className, confidence } = pred;
      //   const [x, y, width, height] = bbox;

      //   ctx.strokeStyle = '#00ff00';
      //   ctx.lineWidth = 2;
      //   ctx.strokeRect(x, y, width, height);

      //   ctx.fillStyle = '#00ff00';
      //   ctx.font = '16px Arial';
      //   ctx.fillText(
      //     `${className} ${Math.round(confidence * 100)}%`,
      //     x, y - 5
      //   );
      // });
    };
    image.src = `data:image/jpeg;base64,${frameData.image_cv}`;
  }

  renderButtonStatus() {
    return (this.state.status === STATUS_IDLE) ?
      'Xuất Báo cáo' :
      <Grid item>
        <CircularProgress aria-label="progress" />
      </Grid>
  }

  generateReport = async () => {
    this.setState({ loading: true, error: null });
    try {
      const response = await axios.post(
        'https://sperms.ailab.vn:5008/generate-report',
        {
          patient_id: this.state.patientID,
          patient_name: this.state.patientName,
          sample_id: this.state.sampleID,
          collection_date: this.state.collectionDate,
        },
        {
          responseType: 'blob'
        }
      );

      // Tạo URL từ blob
      const file = new Blob([response.data], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);

      // Mở PDF trong tab mới
      window.open(fileURL, '_blank');

      // Cleanup URL
      URL.revokeObjectURL(fileURL);

    } catch (err) {
      this.setState({
        error: 'Có lỗi xảy ra khi tạo báo cáo'
      });
      console.error('Error:', err);
    } finally {
      this.setState({ loading: false });
    }
  }

  render() {
    const {
      isLoading,
      isProcessing,
      progress,
      error,
      isPlaying,
      drawingMode,
      selectedBox,
      trackingMode,
      persistentBoxes,
      userBoxes,
      currentFrame,
      frames,
      patientID,
      patientName,
      sampleID,
      collectionDate,
      selectedFrameData,
      selectedFrameNumber,
      selectedFrame,
      selectedFrameOrigin,
      selectedFrameDataOrigin
    } = this.state;

    return (
      <Grid container  className="w-full px-4 md:px-6 lg:px-8" style={{width: "100%"}}>
        <Card className="w-full max-w-full">
          <CardHeader
            title="Phân tích Video"
            subheader="Upload Video để phát hiện và phân loại"
            className="p-4 md:p-6"
          />

          <CardContent className="p-4 md:p-6">
            <div className="mb-4">
              {!isLoading && (
                <input
                  disabled={patientID === "" || patientName === "" || sampleID === "" || collectionDate === "" || collectionDate === null}
                  type="file"
                  accept="video/*"
                  onChange={this.handleFileSelect}
                  className="block w-full text-sm text-gray-500 mb-4"
                />
              )}

              {isProcessing && (
                <div className="mt-4">
                  <LinearProgress variant="determinate" value={progress} />
                  <p className="text-sm text-gray-500 mt-2">
                    Processing: {progress}%
                  </p>
                </div>
              )}

              {error && (
                <p className="text-red-500 mt-2">{error}</p>
              )}
            </div>

            <Grid container spacing={2}>
              {/* Video Panel - Full width on mobile, half width on larger screens */}
              <Grid item xs={12} md={12} lg={6}>
                <div className="relative w-full">
                  <StreamingPanel
                    canvasRef={this.canvasRef}
                    className="w-full h-auto"
                  />
                  <div className="absolute bottom-4 left-4 space-x-2">
                    <Button
                      variant="contained"
                      onClick={this.captureFrame}
                      className="px-4 py-2 bg-black bg-opacity-50 text-white rounded"
                      size="medium"
                    >
                      Hình thái học
                    </Button>
                  </div>
                </div>
              </Grid>

              {/* Annotation Panel - Full width on mobile, half width on larger screens */}
              <Grid item xs={12} md={12} lg={6}>
                <div className="w-full">
                  <AnnotationPanel
                    selectedFrameData={selectedFrameData}
                    selectedFrameNumber={selectedFrameNumber}
                    selectedFrame={selectedFrame}
                    selectedFrameOrigin={selectedFrameOrigin}
                    selectedFrameDataOrigin={selectedFrameDataOrigin}
                    className="w-full h-auto"
                  />
                </div>
              </Grid>

              {/* Report Button - Adjustable width based on screen size */}
              <Grid item xs={12} sm={6} md={4}>
                <Button
                  id="raised-button-file"
                  onClick={this.generateReport}
                  disabled={this.state.status === STATUS_UPLOADING}
                  variant="outlined"
                  component="span"
                  className="w-full md:w-auto"
                >
                  {this.renderButtonStatus()}
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    );
  }
}